<template>
  <div class="row" v-if="entidad_data.puntos_viaje && entidad_data.puntos_viaje.length > 0">
    <table class="table table-sm table-hover" style="font-size: 0.85em;">
      <thead class="thead-dark">
        <tr class="text-center">
          <th>Nombre Sitio/Punto gestión</th>
          <th>Llegada</th>
          <th>Salida</th>
          <th>Tiempo en punto</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in entidad_data.puntos_viaje" :key="item.id">
          <th>{{ item.sitio.nombre }}</th>
          <td class="text-center">{{ item.hora_llegada }}</td>
          <td class="text-center">
            {{ item.actividad == 2 ? item.hora_salida : "N/A" }}
          </td>
          <td class="text-center">{{ item.tiempo_punto }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row" v-else>
    <div class="alert alert-warning col-md-12">
      <h5><i class="icon fas fa-exclamation-triangle"></i> Atención!</h5>
      No se encontraron Puntos de Gestión para este Viaje!
    </div>
  </div>
</template>
<script>
export default {
  name: "GestionInfoPuntosHidrocarburos",

  data() {
    return {};
  },
  props: {
    entidad_data: {
      type: Object,
    },
    type_entidad: {
      type: String,
    },
  },
};
</script>
